export default {
    fontSizes: [12, 14, 16, 24, 32, 48, 64, 96, 128],
    space: [0, 4, 8, 16, 32, 64, 128, 256],
    colors: {
      primary: `tomato`,
    },
  }